// extracted by mini-css-extract-plugin
export var card = "_mj-0";
export var content = "_mj-2";
export var details = "_mj-3";
export var icon = "_mj-1";
export var iconBlue = "_mj-5";
export var iconBrand = "_mj-4";
export var iconGrayBlue = "_mj-6";
export var iconGreen = "_mj-7";
export var iconIndigo = "_mj-8";
export var iconOrange = "_mj-9";
export var iconPurple = "_mj-a";
export var iconRed = "_mj-b";
export var iconWarning = "_mj-c";